
































import { Component, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";

@Component({
  components: {
    "client-registration-fields": () =>
      import("@/components/app/client/clientRegistrationFields.vue"),
    "terms-and-conditions-statement": () =>
      import("@/components/app/global/auth/termsAndConditionsStatement.vue")
  }
})
export default class ClientCompleteRegistrationModal extends Mixins(
  HasValidation
) {
  public user = {
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    custom_fields: {}
  };
  public isProcessing = false;

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.$store.dispatch("auth/guest/completeFullRegistration", {
        clientId: this.$store.state.user.id,
        userData: this.user
      });
      this.$emit("registration-completed");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
